import { Link } from 'react-router-dom';
import { Flame, Wrench, Hammer, Sparkles, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const services = [
    { name: 'Welding', icon: Flame, to: '/services#welding' },
    { name: 'Mechanics', icon: Wrench, to: '/services#mechanics' },
    { name: 'Handyman', icon: Hammer, to: '/services#handyman' },
    { name: 'Cleaning', icon: Sparkles, to: '/services#cleaning' },
  ];

  const quickLinks = [
    { name: 'Home', to: '/' },
    { name: 'Services', to: '/services' },
    { name: 'Book Now', to: '/booking' },
    { name: 'Contact', to: '/contact' },
  ];

  return (
    <footer className="footer py-16 px-6 md:px-12" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#00F0FF] to-[#008F7A] flex items-center justify-center">
                <span className="font-heading text-black font-black text-lg">O</span>
              </div>
              <span className="font-heading text-xl font-bold tracking-wider">
                <span className="text-[#00F0FF]">OMNI</span>
                <span className="text-white">BEAST</span>
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Professional trade services with precision and power. 
              We forge solutions that last.
            </p>
            <div className="flex gap-4">
              {services.map((service) => (
                <service.icon 
                  key={service.name} 
                  className="w-5 h-5 text-[#008F7A] hover:text-[#00F0FF] transition-colors cursor-pointer" 
                />
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-lg font-bold text-white mb-6">Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.name}>
                  <Link
                    to={service.to}
                    className="text-gray-400 hover:text-[#00F0FF] transition-colors flex items-center gap-2"
                  >
                    <service.icon className="w-4 h-4" />
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-bold text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.to}
                    className="text-gray-400 hover:text-[#00F0FF] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-bold text-white mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#00F0FF] shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">
                  Bridgeport, WV<br />
                  & Surrounding Areas
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#00F0FF] shrink-0" />
                <span className="text-gray-400 text-sm">(443) 655-9580</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#00F0FF] shrink-0" />
                <span className="text-gray-400 text-sm">OmniBeastServices@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[#1E293B] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} OmniBeast Services. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-gray-500 text-sm hover:text-[#00F0FF] cursor-pointer transition-colors">
              Privacy Policy
            </span>
            <span className="text-gray-500 text-sm hover:text-[#00F0FF] cursor-pointer transition-colors">
              Terms of Service
            </span>
            <Link
              to="/admin"
              title="Admin Portal"
              data-testid="footer-admin-link"
              className="opacity-50 hover:opacity-100 transition-opacity"
            >
              <img
                src="/omnibeast-wolf.png"
                alt="Admin"
                className="h-10 w-auto"
              />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
